import { importAddressArrayTransformerFashion } from "./addressArrayTransformer";

export const importAddressTransformer = (data: any) => {
  const { response } = data;
  if (data.status == 'success' && response) {
    return {
      success: true,
      title: response.title,
      addresses: importAddressArrayTransformerFashion(response?.addresses || []),
    };
  } else {
    return {
      success: false,
      ...response,
    };
  }
};